import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_get_orders_by_orderaddressid_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { addressId: number }): 
  Promise<{ result: { Id?: number, Order?: { Id?: number, OrderStatusId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.addressId)) {
      missingRequiredInParams.push('\'addressId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Addresses/datasources/ds_get_orders_by_orderaddressid_top1/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      addressId: number    }) {
        if(isNil(inParams.addressId)) {
          return true; 
        }
      return false;
    }
}
